import type { FormField } from '@cli-types/core-engine/schema.js'
import { escapeAttribute, jsString } from '@cli-utils/text.js'
import { renderTextFieldJsxFieldControllerTemplate } from '@next-adapter/templates/renderers/generators/form-pipeline/form-component-shared/generate-text-field-jsx.js'
import { errorMessageLine } from './error-message-line.js'
import { fieldContainerClass } from './field-container-class.js'
import { formLabelWithDescriptionLine } from './form-label-with-description-line.js'
import { inputClass } from './input-class.js'

export function generateTextFieldJSX(
  name: string,
  label: string,
  placeholder: string,
  hintJSX: string,
  requiredStar: string,
  inputType: string,
  height?: FormField['height']
): string {
  return renderTextFieldJsxFieldControllerTemplate({
    name: name,
    fieldContainerClass: fieldContainerClass(height),
    formLabelWithDescriptionLine: formLabelWithDescriptionLine(
      name,
      label,
      requiredStar,
      hintJSX,
      '              '
    ),
    inputType: inputType,
    escapeAttribute: escapeAttribute(placeholder),
    inputClass: inputClass(height),
    errorMessageLine: errorMessageLine(jsString(name), '              ')
  })
}
